module.exports = __webpack_public_path__ + "img/cute_natural_doodle_2.4743f591.png";